import React, {PureComponent} from 'react'
import cn from "classnames"
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import {NavLink} from 'redux-first-router-link'
import injectStyles from "react-jss"
import theme from "../../styles/theme"
import get from "lodash/get"
import { trackEvent, CONTENT_ROUTE } from "../../actions"

class Link extends PureComponent {

    _handleTracking = () => {
        const {handleTracking, link} = this.props;
        handleTracking(link)
    }

    _handleNavigation = () => {
        const {handleNavigation, link} = this.props;
        if(link && link.url) handleNavigation(link)
    }

    render() {
        const {link, size, isLoading, children, activeClassName, className, classes, sheet, handleTracking, handleNavigation, fake=false, hover=false, ...rest} = this.props;

        const classNames = cn(get(classes, ["link"]), size && get(classes, size.toLowerCase()), className, link && link.class_name, {hover: hover});
        if(fake || !link || !link.url) return <div className={classNames} onClick={this._handleNavigation} {...rest} >{children || link.label}</div>;
        const tag = ! link.url.startsWith("http") ?
            <NavLink rel={link.rel} onClick={this._handleTracking} activeClassName={activeClassName} exact to={link.url} className={classNames} {...rest}>{children || link.label}</NavLink> :
            <a rel={link.rel} onClick={this._handleTracking} href={link.url} className={classNames} target={link.target} {...rest}>{children || link.label}</a>;
        return tag;
    }
}

Link.propTypes = {
    link: PropTypes.object,
    onClick:PropTypes.func,
    target: PropTypes.string,
    className: PropTypes.string,
    containerClassName: PropTypes.string,
    activeClassName: PropTypes.string,
    style: PropTypes.object,
    track: PropTypes.object,    
    size: PropTypes.string
}

const mapStateToProps = (state) => ({})

const mapDispatchToProps = (dispatch) => {
    return {
        handleTracking: (link) => {
            dispatch( trackEvent(link.url, link.ga_tracking) );
        },
        handleNavigation: (link) => {
            dispatch( trackEvent(link.url, link.ga_tracking) );
            dispatch( { type: CONTENT_ROUTE, payload: [ link.url ] } );
        }
    }
}

export const UnstyledLink = connect(mapStateToProps, mapDispatchToProps)(Link);

const TRANSITION = `transform 0.2s ${theme.animation.easing.standardCurve}`;

export default injectStyles({
    link: {
        ...theme.font.link,
        display: "inline-block",
        textDecoration: "none",
        color: theme.colors.black,
        position: "relative",
        transition: TRANSITION,
        whiteSpace: 'nowrap',
        letterSpacing: '0.8px',
        cursor: 'pointer',
        "&:after": {
            transition: TRANSITION,
            content: '""',
            position: "absolute",
            width: "100%",
            height: 1,
            backgroundColor: theme.colors.primary,
            bottom: "0.4rem",
            left: 0
        },
        "& div": {
            transition: TRANSITION,
            display: "block"
        },
        "&:hover, &.hover": {
            color: theme.colors.primary
        }
    },
    large: {
      fontSize: theme.getRemValue(14),
      lineHeight: theme.getRemValue(24),
      [theme.breakpoint("tablet")]: {
        fontSize: theme.getRemValue(16)
      },
      "&:after": {
        height: 2,
        bottom: 0
      }
    }    
})(connect(mapStateToProps, mapDispatchToProps)(Link))





// WEBPACK FOOTER //
// ./src/components/Widgets/Link.js